export default __webpack_public_path__ + "static/useful-938072ffe15fe4f2a6d2319175450464.jpeg";